import { createResourceBuilder } from '../resource';
import { EResourceMethod } from '../models/IPermission';
import { orgNameParam, userIdParam } from './builderHelper';

export const zendeskResources = {
  reassignUser: createResourceBuilder(
    '/zendeskrust/zendesk/user/:user_id/reassign',
    EResourceMethod.Post,
    userIdParam()
  ),
  reassignOrganization: createResourceBuilder(
    '/zendeskrust/zendesk/organization/:organization_name/reassign',
    EResourceMethod.Post,
    orgNameParam()
  ),
  getUserTickets: createResourceBuilder(
    '/zendeskrust/zendesk/user/:user_id/tickets/:zendesk_id',
    EResourceMethod.Get,
    (user_id: string, zendesk_id: string) => ({ user_id, zendesk_id })
  ),
};
